import { render } from "./GroupedInputButton.vue?vue&type=template&id=24b10332&scoped=true"
const script = {}

import "./GroupedInputButton.vue?vue&type=style&index=0&id=24b10332&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b10332"]])

export default __exports__